export const MEDIA_LIBRARY_TYPES = {
    TYPE_PHOTO: 'photo',
    TYPE_VIDEO: 'video',
    TYPE_DOCUMENT: 'document'
};
